import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/app/components/ui/PageHeader';

/**
 * Placeholder for `/manage` (§ Beheer): WP-13 builds the real section pages
 * behind `ManageLayout`'s menu. WP-08 only needs a landing page so `/manage`
 * itself resolves to something instead of 404ing before any section page
 * exists.
 */
export function ManageIndexPage() {
  const { t } = useTranslation();
  return (
    <section>
      <PageHeader title={t('shell.manageStub.title')} lead={t('shell.manageStub.lead')} />
    </section>
  );
}
